import { useMediaQuery as muiUseMediaQuery } from "@mui/material";

/**
 * useMediaQuery hook wrapper for responsive breakpoints.
 * Wraps Material-UI useMediaQuery for consistent imports.
 * 
 * @example
 * const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
 */
export const useMediaQuery = (...args) => {
  return muiUseMediaQuery(...args);
};

export default useMediaQuery;
